import { render, staticRenderFns } from "./Regio.vue?vue&type=template&id=60418b37&scoped=true&"
import script from "./Regio.vue?vue&type=script&lang=js&"
export * from "./Regio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60418b37",
  null
  
)

export default component.exports